import React from 'react';
import { Stack, Typography } from '@mui/material';
import { BILLING_CYCLE_OPTIONS, CHECKOUT_COPY, CYCLE_CHIP } from 'lib/billing';
import { PillTabs, PillTabsOption } from '../PillTabs';
import { useCheckoutActions, useCheckoutState } from '../store';
import { SECTION_LABEL_SX } from './sharedStyles';

const BILLING_PILL_OPTIONS: PillTabsOption<string>[] = BILLING_CYCLE_OPTIONS.map((o: any) => ({
  id: o.id,
  label: o.label,
  chip: (CYCLE_CHIP as any)[o.id] || null
}));

export function BillingCycleTabs() {
  const state = useCheckoutState();
  const actions = useCheckoutActions();
  const billingCycle = state.billingCycle;
  const COPY = state.isModifyingExisting ? CHECKOUT_COPY.configureModify : CHECKOUT_COPY.configure;

  return (
    <Stack spacing={1}>
      <Typography variant="overline" sx={SECTION_LABEL_SX}>
        {COPY.sectionBilling}
      </Typography>
      <PillTabs
        options={BILLING_PILL_OPTIONS}
        value={billingCycle || BILLING_PILL_OPTIONS[0]?.id}
        onChange={(id) => actions.setBillingCycle(id)}
        ariaLabel={COPY.sectionBilling}
      />
    </Stack>
  );
}
